<template>
  <toolbar app dense bg-color="gray" color="white" tag="footer" ref="app" :bg-color-lightness="900" :z-index="900" :class="['duration-300', 'transition-all']">
    <toolbar-icon :class="['text-xs', 'pl-4']">
      <span :class="['hidden', 'md:block']">&copy;{{ $root.date.getFullYear() }} <router-link to="/" v-html="$config.appName" /> | <router-link to="/getting-started/release-notes">{{ $config.version }}</router-link> | <router-link to="/sitemap" v-html="$lang.sitemap" :title="$lang.sitemap" /></span>
    </toolbar-icon>
    <toolbar-actions width="70%" :class="['text-xs', 'px-4']">
      <switcher v-model="$root.nightShift" label-color="white" label-size="xs" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" :label-color-lightness="null" :title="$lang.nightShift" :label="$lang.nightShift" /><!--
      --><switcher v-model="$dark" label-color="white" label-size="xs" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" :label-color-lightness="null" :title="$lang.theme" :label="$lang.theme" />
    </toolbar-actions>
  </toolbar>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>



// WEBPACK FOOTER //
// src/components/app-footer.vue